module.exports = __webpack_public_path__ + "static/img/8.31cfd293.png";